import { nextTick, openBlock, createElementBlock } from 'vue';
import { Options, Vue } from 'vue-class-component';
import { tsParticles } from 'tsparticles';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

let Particles = class Particles extends Vue {
    mounted() {
        nextTick(() => {
            var _a;
            if (!this.id) {
                throw new Error("Prop 'id' is required!");
            }
            tsParticles.init();
            if (this.particlesInit) {
                this.particlesInit(tsParticles);
            }
            const cb = (container) => {
                this.container = container;
                if (this.particlesLoaded && container) {
                    this.particlesLoaded(container);
                }
            };
            if (this.url) {
                tsParticles
                    .loadJSON(this.id, this.url)
                    .then(cb);
            }
            else {
                tsParticles
                    .load(this.id, (_a = this.options) !== null && _a !== void 0 ? _a : {})
                    .then(cb);
            }
        });
    }
    beforeDestroy() {
        if (this.container) {
            this.container.destroy();
        }
    }
};
Particles = __decorate([
    Options({
        props: {
            id: {
                type: String,
                required: true
            },
            options: {
                type: Object
            },
            url: {
                type: String
            },
            particlesLoaded: {
                type: Function
            },
            particlesInit: {
                type: Function
            }
        }
    })
], Particles);
var script = Particles;

const _hoisted_1 = ["id"];

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("div", { id: _ctx.id }, null, 8 /* PROPS */, _hoisted_1))
}

script.render = render;
script.__file = "src/Particles/Particles.vue";

const VueParticles = (app, options) => {
    app.component("Particles", script);
};

export { script as ParticlesComponent, VueParticles as default };
